var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurplePinkLarge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 382.104,
    height: 486.306,
    viewBox: "0 0 382.104 486.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "purple-pink__large",
    d: "M-11299.735-6850.876c-3.073-11.474,4.094-23.364,16.007-26.556s24.068,3.521,27.142,15-4.093,23.361-16.006,26.556a23.156,23.156,0,0,1-6,.794A21.663,21.663,0,0,1-11299.735-6850.876Zm41.109-60.268c-22.3-17.569-47.944-1.857-62.717,2.1-57.72,15.466-111.794-17.309-127.09-74.4-16.252-61.12,19.7-73.374,9.684-111.268.309-.378.624-.749.947-1.106-.733-.208-1.447-.434-2.141-.67-8.449-20.325-43.851-39.376-53.378-74.928-17.046-59.62,17.075-118.845,72.856-133.791s113.275,18.753,128.421,75.274c3.929,14.666,9.392,38.64,27.96,54.452,27.926,10.27,56.178,37.395,65.008,70.352,5.125,19.124,5.639,53.944,24.335,67.818a79.851,79.851,0,0,1,56.376,56.469A79.882,79.882,0,0,1-11174.85-6883a80.016,80.016,0,0,1-20.726,2.741A80.065,80.065,0,0,1-11258.626-6911.144Zm-7.349-373.532a21.508,21.508,0,0,1,0-30.418,21.509,21.509,0,0,1,30.415,0,21.508,21.508,0,0,1,0,30.418,21.445,21.445,0,0,1-15.209,6.3A21.436,21.436,0,0,1-11265.975-7284.676Z",
    transform: "translate(11497.727 7321.393)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePinkLarge);
export default __webpack_public_path__ + "static/media/purple-pink__large.17ed9ec05cf0b4df001b3a7d964c7f07.svg";
export { ForwardRef as ReactComponent };